import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../app.settings';
import { ICreateApplicationRequest } from '../../classes/existing-onboarding-customer/requests';
import {
	CreateApplicationResponse,
	GetRegisteredMobileNumbersResponse,
} from '../../classes/existing-onboarding-customer/responses';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { ContactInfoModalComponent } from '../contact-info-modal/contact-info-modal.component';
import { CreatePasswordComponent } from '../create-password/create-password.component';
import { BaseComponent } from '../../../globals/classes/base.component';

@Component({
	selector: 'create-password-intro-modal',
	template: require('./create-password-intro-modal.component.html'),
})
export class CreatePasswordIntroModalComponent extends BaseComponent implements OnInit {
	@Input() ibUsernameRequest: string;
	@Input() getRegisteredMobileNumbersResponse: GetRegisteredMobileNumbersResponse;
	@Input() appCreateAppResponse: CreateApplicationResponse;
	@Input() public isExistingCustomer = false;
	@Input() createAppRequest: ICreateApplicationRequest;
	@Input() public isCardModalflow: boolean = false;
	@Input() public isForgetCredentialsRetailModalflow: boolean = false;
	@Input() public ibUsernameCheckUsernameAvailabilityResp: string;
	public isRebrading = AppSettings.isRebrading;
	public isLoginBigModalEnabled: boolean = AppSettings.isLoginBigModalEnabled;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;
	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {
		super();
	}

	public ngOnInit(): void {
		if (this.dynatraceForExistingOnBoarding) this._setLoadSplashDynatraceEvent();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public toggleCardDetails(): void {
		this.activeModal.close();
		this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
	}

	public toggleCreatePassword(): void {
		this.activeModal.close();
		const modalRef = this.modalService.open(CreatePasswordComponent, {
			windowClass: !this.isLoginBigModalEnabled ? 'modal-small' : 'modal-full',
		});
		(modalRef.componentInstance as CreatePasswordComponent).isOnBoardingFlow = true;
		(modalRef.componentInstance as CreatePasswordComponent).getRegisteredMobileNumbersResponse =
			this.getRegisteredMobileNumbersResponse;
		(modalRef.componentInstance as CreatePasswordComponent).appCreateAppResponse =
			this.appCreateAppResponse;
		(modalRef.componentInstance as CreatePasswordComponent).ibUsernameRequest =
			this.ibUsernameRequest;
		(
			modalRef.componentInstance as CreatePasswordComponent
		).ibUsernameCheckUsernameAvailabilityResp = this.ibUsernameCheckUsernameAvailabilityResp;
		(modalRef.componentInstance as CreatePasswordComponent).isExistingCustomer =
			this.isExistingCustomer;
		(modalRef.componentInstance as CreatePasswordComponent).createAppRequest =
			this.createAppRequest;
		(modalRef.componentInstance as CreatePasswordComponent).isCardModalflow =
			this.isCardModalflow;
		(modalRef.componentInstance as CreatePasswordComponent).isForgetCredentialsRetailModalflow =
			this.isForgetCredentialsRetailModalflow;
	}

	public toggleContactInfo(): void {
		this.activeModal.close();
		const modalRef = this.modalService.open(ContactInfoModalComponent, {
			windowClass: 'modal-small',
		});
		(
			modalRef.componentInstance as ContactInfoModalComponent
		).getRegisteredMobileNumbersResponse = this.getRegisteredMobileNumbersResponse;
		(modalRef.componentInstance as ContactInfoModalComponent).appCreateAppResponse =
			this.appCreateAppResponse;
		(modalRef.componentInstance as ContactInfoModalComponent).isExistingCustomer =
			this.isExistingCustomer;
		(modalRef.componentInstance as ContactInfoModalComponent).appRequest =
			this.createAppRequest;
		(modalRef.componentInstance as ContactInfoModalComponent).isCardModalflow =
			this.isCardModalflow;
		(
			modalRef.componentInstance as ContactInfoModalComponent
		).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}

	private _setLoadSplashDynatraceEvent() {
		this.setDynatraceEvent('ECO_Splash_Icon_Loaded');
	}
}
